var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('el-dialog', {
    attrs: {
      "title": _vm.$t('sc.gallery.newFolderTitle'),
      "visible": _vm.visible,
      "width": "480px",
      "append-to-body": "",
      "close-on-click-modal": false
    },
    on: {
      "close": _vm.handleClose
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function () {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.submitting
          },
          on: {
            "click": _vm.handleSubmit
          }
        }, [_vm._v("\n      " + _vm._s(_vm.$t('sc.gallery.confirm')) + "\n    ")]), _vm._v(" "), _c('el-button', {
          on: {
            "click": _vm.handleClose
          }
        }, [_vm._v("\n      " + _vm._s(_vm.$t('sc.gallery.cancel')) + "\n    ")])];
      },
      proxy: true
    }])
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-position": "top"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('sc.gallery.parentFolder')
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": _vm.$t('sc.gallery.pleaseSelect'),
      "options": _vm.cleanedDirectoryTree,
      "props": _vm.cascaderProps,
      "clearable": ""
    },
    model: {
      value: _vm.form.parentId,
      callback: function ($$v) {
        _vm.$set(_vm.form, "parentId", $$v);
      },
      expression: "form.parentId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('sc.gallery.folderName')
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('sc.gallery.folderNamePlaceholder')
    },
    model: {
      value: _vm.form.name,
      callback: function ($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }